import React from "react"

import { webSuppliers } from "@signals"
import { AppWebSuppliersAutocomplete } from "@components/Autocomplete"


export default function AppCommonFiltersWebSuppliersAutocomplete({ ...props }) {
	return <AppWebSuppliersAutocomplete
		value={webSuppliers.value}
		onChange={e => webSuppliers.value = e.target.value}
		{...props}
	/>
}